import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
import { connect } from 'react-redux';
import { routeActions } from 'redux-simple-router';
import CreateSalary from './CreateSalary';
import SalaryContainer from './salaryContainer';

class salary extends Component {
  getQueryObject = () => {
    if(this.props.location.query.obj){
      try {
        return JSON.parse(this.props.location.query.obj);
      }
      catch(e) {
        this.props.dispatch(routeActions.push("/lon"))
      }
    }
  };
	render() {
    let queryObject = this.getQueryObject();
		return (
			<div className="container" style={styles.container}>
        {!queryObject ?
          <CreateSalary/>
          :
          <SalaryContainer
            queryObject={queryObject}
            /*attemptGetSalaryObject={(payload) => dispatch(attemptGetSalaryObject(payload))}*/
          />
        }

      </div>
		);
	}
}

var styles = {
  container: {
  }
}
salary.propTypes = {
    dispatch: PropTypes.func.isRequired
  };

export default connect()(Radium(salary));


// WEBPACK FOOTER //
// ./src/App/Project/Salary/index.jsx